import React from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Select from 'react-select';
import moment from 'moment';
import { DATE_FORMAT_ISO, DATE_FORMAT_WEB } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';

const AdditionalOptionsSection = ({ data, onChange, airports, getReactSelectStyles }) => {
  return (
    <>
      <h6 className="text-primary mb-3 mt-4">
        <i className="fa fa-cog me-2"></i>Additional Options
      </h6>
      <Row>
        <Col>
          <Form.Check
            inline
            label="Hotel Needed"
            type="checkbox"
            checked={data.isHotelNeeded}
            onChange={(e) => onChange({ isHotelNeeded: e.target.checked })}
          />
        </Col>
        <Col>
          <Form.Check
            inline
            label="Book Return Flight"
            type="checkbox"
            checked={data.isBookReturnFlight}
            onChange={(e) => {
              if (!e.target.checked) {
                onChange({
                  isBookReturnFlight: false,
                  brfReturnFlightDate: null,
                  brfDepartureAirport: null,
                  brfArrivalAirport: null,
                });
              } else {
                onChange({ isBookReturnFlight: true });
              }
            }}
          />
        </Col>
        <Col>
          <Form.Check
            inline
            label="Train Ticket"
            type="checkbox"
            checked={data.isRailAndFly}
            onChange={(e) => {
              if (!e.target.checked) {
                onChange({ isRailAndFly: false, homeTrainStationName: '' });
              } else {
                onChange({ isRailAndFly: true });
              }
            }}
          />
        </Col>
      </Row>

      {data.isBookReturnFlight && (
        <>
          <h6 className="text-secondary mb-3 mt-4">Book Return Flight Details</h6>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Return Flight Date</Form.Label>
              <Datetime
                timeFormat={false}
                dateFormat={DATE_FORMAT_WEB}
                closeOnSelect
                utc={true}
                inputProps={{ placeholder: DATE_FORMAT_WEB }}
                value={DateTimeFormater(data.brfReturnFlightDate, null, DATE_FORMAT_WEB)}
                onChange={(e) => {
                  if (moment.isMoment(e) && e.isValid()) {
                    onChange({ brfReturnFlightDate: e.format(DATE_FORMAT_ISO) });
                  }
                }}
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Departure Airport</Form.Label>
              <Select
                options={airports}
                isSearchable
                isClearable
                isMulti
                styles={getReactSelectStyles(false)}
                onChange={(e) => onChange({ brfDepartureAirport: e?.map((x) => x.value) || [] })}
                value={airports.filter((x) => data.brfDepartureAirport?.includes(x.value))}
                placeholder="Select airports"
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Arrival Airport</Form.Label>
              <Select
                options={airports}
                isSearchable
                isClearable
                isMulti
                styles={getReactSelectStyles(false)}
                onChange={(e) => onChange({ brfArrivalAirport: e?.map((x) => x.value) || [] })}
                value={airports.filter((x) => data.brfArrivalAirport?.includes(x.value))}
                placeholder="Select airports"
              />
            </Form.Group>
          </Row>
        </>
      )}

      {data.isRailAndFly && (
        <>
          <h6 className="text-secondary mb-3 mt-4">Train Ticket Details</h6>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Train Station Name</Form.Label>
              <Form.Control
                type="text"
                value={data.homeTrainStationName}
                onChange={(e) => onChange({ homeTrainStationName: e.target.value })}
                placeholder="Enter train station name"
              />
            </Form.Group>
          </Row>
        </>
      )}

      <Row className="mt-3">
        <Form.Group as={Col}>
          <Form.Label>Comments</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={data.comment || ''}
            onChange={(e) => onChange({ comment: e.target.value })}
            placeholder="Add any additional comments"
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col}>
          <Form.Label>Upload Files</Form.Label>
          <Form.Control
            type="file"
            multiple
            onChange={(e) => {
              const files = e.target.files;
              if (files && files.length > 0) onChange({ selectedFiles: Array.from(files) });
            }}
          />
        </Form.Group>
      </Row>
    </>
  );
};

AdditionalOptionsSection.propTypes = {
  data: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  airports: PropTypes.array.isRequired,
  getReactSelectStyles: PropTypes.func.isRequired,
};

export default AdditionalOptionsSection;
